<template>
    <div class="checkbox-wrap-container">
        <label role="checkbox" :class="['checkbox-wrap', type]" :disabled="disabled">
            <input v-model="checked" type="checkbox" @change="updateValue" class="checkbox-original" @click="click" :disabled="disabled">
            <span :class="[checked ? 'checked' : 'no-checked', 'reo-checkbox', type, size]" v-show="!myOnlyLabel">
                <span :class="[checkIcon, 'check-icon']"></span>
            </span>
            <span :class="['checkbox-label', {'underline': myOnlyLabel, 'label-check': checked}, color]" v-if="label">{{ (labelOnSelect && checked) ? labelOnSelect : label}}</span>
        </label>
        <span class="text" v-if="text" v-html="text"></span>
    </div>
</template>

<script>
export default {

    props: {

        value: {

            required: true

        },

        type: {

            type: String,
            validator ( type ) {

                let types = ['fill', 'original', 'circle', 'highlight'];
                return types.indexOf( type ) !== -1;

            },
            default () {

                return 'original';

            }

        },

        label: {

            type: String

        },

        labelOnSelect: {

            type: String

        },

        onlyLabel: {

            default () {

                return false;

            }

        },

        color: String,

        size: {

            type: String,
            validator ( type ) {

                let types = ['small', 'middle'];
                return types.indexOf( type ) !== -1;

            },
            default () {

                return 'middle';

            }

        },

        text: String,

        disabled: {

            type: Boolean,
            default () {

                return false;

            }

        }

    },

    data () {

        return {

            checked: this.value

        };

    },

    methods: {

        updateValue () {

            this.$emit( 'input', this.checked );

        },

        click () {

            if ( this.disabled ) {

                return false;

            }
            this.$nextTick(() => {

                this.$emit( 'click', this.checked );

            });

        }

    },

    watch: {

        value ( value ) {

            this.checked = value;

        }

    },

    computed: {

        myOnlyLabel () {

            if ( typeof this.onlyLabel === 'string' ) {

                return true;

            } else {

                return false;

            }

        },
        checkIcon () {

            let type = this.type;
            if ( type === 'circle' ) {

                return 'circle-check';

            } else {

                return 'icon-check';

            }

        }

    }

};
</script>

<style lang="less" scoped>
    .checkbox-wrap-container{
        display: inline-block;
    }
    .checkbox-wrap{
        display: inline-block;
        cursor: pointer;
        user-select: none;
    }
    .reo-checkbox{
        display: inline-block;
        box-sizing: border-box;
        width: 24px;
        height: 24px;
        border: 1px solid #ccc;
        border-radius: 6px;
        background-color: #fff;
        position: relative;
        vertical-align: middle;
        font-size: 16px;
        &.highlight{
            border-color: @theme;
        }
        &.circle{
            border-radius: 100%;
        }
        &:not(.checked) .check-icon{
            display: none;
        }
        .check-icon{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            color: @theme;
        }
        .circle-check{
            transform: none;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            display: block;
            height: auto;
            width: auto;
            border: none;
            background-color: @theme;
            border-radius: 100%;
            margin: 3px;
        }
        &.fill{
            .check-icon{
                color: #fff;
            }
        }
        &.small{
            width: 16px;
            height: 16px;
            font-size: 12px;
            border-radius: 2px;
        }
        @media @mobile{
            &{
                width: 0.36rem;
                height: 0.36rem;
                border-radius: 0.04rem;
            }
            &.small{
                width: 0.32rem;
                height: 0.32rem;
                border-radius: 0.04rem;
            }
            .check-icon{
                font-size: 0.2rem;
            }
            &.small .check-icon{
                font-size: 0.16rem;
            }
            &.small.circle,
            &.circle{
                width: 0.34rem;
                height: 0.34rem;
                border-radius: 100%;
                .circle-check{
                    margin: 0.04rem;
                }
            }
        }
    }
    .reo-checkbox.original{
        border-color: #ccc;
    }
    .reo-checkbox.checked{
        background-color: #fff;
    }
    .reo-checkbox.checked.fill{
        background: @theme-linear-gradient;
        border: none;
    }
    .checkbox-original{
        opacity: 0;
        outline: none;
        position: absolute;
        margin: 0;
        width: 0;
        height: 0;
        z-index: -1;
    }
    .checkbox-label{
        font-size: 0.16rem;
        font-weight: 500;
        color: @theme;
        line-height: 0.24rem;
        vertical-align: middle;
        margin-left: 0.1rem;
    }
    .checkbox-label.underline.label-check{
        text-decoration: underline;
    }
    .checkbox-label.underline{
        margin-left: 0;
    }
    @media screen and (max-width:1199px){
        .checkbox-label{
            font-size: 0.24rem;
        }
    }
    .text{
        margin-left: 0.1rem;
        font-size: 0.16rem;
        vertical-align: middle;
        @media @mobile{
            font-size: 0.26rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/basic/Checkbox.vue